/*
	Search-order change detection
 */

const orderSelect = document.querySelector('.js__serp_order_select');
if (orderSelect) {
	orderSelect.addEventListener('change', () => {
		const selected = orderSelect.elements['serp-sortorder']
													.value
													.split('-', 2);
		
		let searchUrl = new URL(window.location.href);

		const sort = searchUrl.searchParams.get('sort', selected[0]);
		const direction = searchUrl.searchParams.get('direction', selected[1]);
		if(sort == selected[0] && direction == selected[1]) {
			// selected and given parameter are the same:
			return;
		}

		// add order parameters to URL
		searchUrl.searchParams.set('sort', selected[0]);
		searchUrl.searchParams.set('direction', selected[1]);
		
		window.location.href = searchUrl;
		return;
	});
}
